import { useState } from "react";
import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import Benefits from "../../components/allModels/benefits";
import BuiltWork from "../../components/allModels/builtWork";
import EfiModel from "../../components/allModels/efiModel";
import FeatureCard from "../../components/allModels/featureCard";
import GasPowerBennar from "../../components/allModels/gasPowerBennar";
import GoFaster from "../../components/allModels/goFaster";
import MachineInfoCard from "../../components/allModels/machineInfoCard";
import BuildTuatara from "../../components/home/buildTuatara/buildTuatara";
import DealerLocator from "../../components/home/dealerLocator/dealerLocator";
import TuataraMotion from "../../assets/png/Tuatara_in_motion.png";
import Tuatara_with_trailer from "../../assets/images/Tuatara_with_trailer.JPG";
import ArielView1500E from "../../assets/png/ArielView1500E.png";
import GASOLINEIMG from "../../assets/png/1000_EFI _GASOLINE.png";
import DC2500E_1 from "../../assets/images/DC2500E_1.jpg";
import GravelRoad from "../../assets/png/Gravel_Road.png";

import ElectricDual_two from "../../assets/images/ElectricDual_One(2).jpg";
import ElectricDual_three from "../../assets/images/ElectricDual_One(3).jpg";
import ElectricDual_Four from "../../assets/images/ElectricDual_One(4).jpg";
import ElectricDual_one from "../../assets/images/SC2500E/SC2500E(1).jpg";
import ElectricDual_Five from "../../assets/images/SC2500E/SC2500E(2).jpg";
import ElectricDual_Six from "../../assets/images/SC2500E/SC2500E(3).jpg";
import ElectricDual_Seven from "../../assets/images/SC2500E/SC2500E(4).jpg";
import TU01 from "../../assets/png/TU01.png";


const TuDcOneModelFive = () => {
  const infoArray = ["ELECTRIC POWER", "POWER TILT BED", "TRANSFORMING CARGO BED", "DUAL CABIN"];
  const [info, setInfo] = useState([
    {
      title: "ECO-FRIENDLY",
      subTitle: "Zero Emissions, Quiet Performance",
      dec: "The electric-powered Tuatara is designed for durability and sustainability, making it a versatile utility vehicle for any job. Its electric motor provides a range of 30-50 miles on a single charge with a top speed of 27 MPH, and a load capacity of 2,200 lbs. Built with all-steel construction and anti-rust treatment, it’s engineered to handle tough terrain while offering a greener, low-maintenance alternative to traditional gas-powered UTVs. Ideal for both work and off-road adventures, the electric Tuatara combines eco-friendly power with rugged performance, making it perfect for industries and environments that demand both strength and sustainability.",
      img: TuataraMotion,
    },
    {
      title: "HYDRAULIC BED TILT",
      subTitle: "Power Tilt on Cargo Bed, Flat Bed, and Trailer",
      dec: "The Tuatara utility vehicle is equipped with a power tilt system that allows for easy lifting and dumping of the cargo bed, making it ideal for transporting and unloading heavy loads efficiently. ",
      dec2: "When combined with a trailer, the power tilt system ensures quick and effortless loading and unloading, making Tuatara an exceptional choice for industries like agriculture, construction, and waste management, where adaptability and efficiency are crucial.",
      img: Tuatara_with_trailer,
    },

    {
      title: "EVOLVES TO YOUR CARGO",
      subTitle: "Easily Convert the Cargo Bed to a Flat Bed",
      dec: "The Tuatara is built with adaptability in mind, allowing it to easily evolve to meet the demands of any job. One of its standout features is the ability to convert the cargo bed into a flat bed, offering greater versatility for hauling larger or irregular loads. This quick-change capability makes the Tuatara ideal for industries where different tasks require flexible solutions. ",
      dec2: "Whether you need a standard cargo bed for transporting equipment or a flat bed for oversized materials, the Tuatara is designed to adjust and keep you moving efficiently.",
      img: ArielView1500E,
    },
    {
      title: "EVOLVES TO YOUR CARGO",
      subTitle: "Easily Convert the Cargo Bed to a Flat Bed",
      dec: "The 6-seat Dual Cabin Tuatara Utility Vehicle offers increased capacity without compromising on performance or durability. With room for six passengers, it’s ideal for larger crews and families. This extended cabin maintains the same rugged steel frame and off-road capability that Tuatara is known for, while providing extra space for both passengers and equipment. The vehicle can be converted from a standard configuration to a flatbed, offering versatility for hauling larger loads or specialized gear. Whether for work or adventure, the 6-seat option delivers more space, power, and utility for demanding tasks.",
      img: DC2500E_1,
    },
  ]);

  const [machineInfo, setMachineInfo] = useState([
    {
      img: ElectricDual_one,
      title: "TU-SC2500E-01",
      subTitle: "DUAL MOTOR ELECTRIC POWERED UTILITY VEHICLE",
      btnName: "EXPLORE 1000EFI",
      thumbnails: [
        ElectricDual_one,
        ElectricDual_Seven,
        ElectricDual_Six,
        ElectricDual_Five
        // ElectricDual_two,
        // ElectricDual_three,
        // ElectricDual_Four,
      ],
      features: [
        "Dual Electric Motor (10kW / 15kW)",
        "Lithium Iron Phosphate Battery",
        "Regenerative Braking System",
        "85-100 Mile Max Range",
      ],
      specSheetUrl: "/assets/pdf/TUATARASC2500EDualmotor3seatSPECSHEET.pdf",
    },
  ]);

  const [modelInfo, setModelinfo] = useState({
    title: (
      <h1 className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          2500E
          <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            {" "}
            Model
          </span>
        </span>
      </h1>
    ),
    dec: `The dual-motor electric-powered Tuatara is designed for both strength and efficiency. With its powerful dual motors, the vehicle delivers impressive torque and smooth acceleration, providing the performance needed for commercial applications.`,
    dec2: "This model offers both 3-seater and 6-seater options, with the flexibility to convert from a standard bed to a flatbed, making it adaptable for various industries. Built with an all-steel construction, the electric Tuatara delivers long-lasting durability and low-maintenance operation, perfect for those looking for a sustainable yet powerful workhorse.",
  });

  const GoFasterInfo = {
    title: "GO ELECTRIC, GO ANYWHERE",
    list: ["12-26.5 KWH PRO BATTERY", "3.5 HR RAPID CHARGE & OPPORTUNITY CHARGING"],
    info: [
      `Our 12 to 26.5kWh pro batteries double your range, giving you up to 30-50 miles of continuous use. Whether it's long days in the field or extended off-road adventures, the Tuatara’s enhanced battery options ensure you have the power you need.`,
      `The electric Tuatara comes equipped with a 3.5-hour rapid charge system, minimizing downtime and keeping you productive. This fast-charging capability means that even during a busy workday, you can recharge quickly and get back to the job. Plus, with opportunity charging, you can top up your battery at any point, keeping you moving.`,
    ],
  };
  const BenefitsInfo = [
    {
      title: "ENHANCED PERFORMANCE",
      subTitle:
        "The dual motors provide superior torque and power, enabling the vehicle to tackle tough terrains and heavy loads with ease, making it ideal for both work and recreational use.",
    },
    {
      title: "LOW MAINTENANCE COSTS",
      subTitle:
        "With fewer moving parts than combustion engines, the dual motor design requires less maintenance, leading to lower operating costs over time and increased reliability in demanding conditions.",
    },
    {
      title: "IMPROVED OPERATOR COMFORT",
      subTitle:
        "Quieter, more spacious cab with improved visibility helps operators work more productively throughout the day. Ideal for environments requiring low noise, such as farms, parks, or residential areas.",
    },
  ];
  const seoData = seoConfig.us.tuSC2500E1;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <GasPowerBennar
        title={modelInfo.title}
        description={modelInfo.dec}
        bannerText="DUAL MOTOR"
      />
      <EfiModel modelInfo={modelInfo} hideTitle={true} hideDescription={true} />
      <MachineInfoCard activeMachine={machineInfo} />
      <GoFaster GoFasterInfo={GoFasterInfo} />
      <Benefits BenefitsInfo={BenefitsInfo} />
      {/* <DealerLocator /> */}
      <FeatureCard />
      <BuiltWork info={info} infoArray={infoArray} />
      <BuildTuatara />
    </>
  );
};
export default TuDcOneModelFive;
